import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index.vue'
import Intel from '@/views/Intel.vue'
import Ryzen from '@/views/Ryzen.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      {
          path: '/',
          name: 'Index',
          component: Index
      },
      {
          path: '/Intel',
          name: 'Intel',
          component: Intel
      },
      {
          path: '/Ryzen',
          name: 'Ryzen',
          component: Ryzen
      },

  ]
})
